import _isEmpty from 'lodash/isEmpty'
import _isString from 'lodash/isString'

const maskRegEx =
  /(\d\d+|(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,}))/g // eslint-disable-line
const maskPattern = '#########'

// Function to filter list of words from url for SEO purpose
export const filterURLWordSEO = (articleTitle) => {
  //TODO:: check on this later
  // try {
  //   if (true) {
  //     // Will remove special character from the string to filter out words
  //     const specialCharactersToReplace = /[?.,!{}()"-]/g; // Add characters here to remove it from the article
  //     const seoWordsLowerCase = seoURlFilter.filterWords.map((item) => item.toLowerCase());
  //     return articleTitle
  //       .replace(specialCharactersToReplace, '')
  //       .toLowerCase()
  //       .split(' ')
  //       .filter((item) => !seoWordsLowerCase.includes(item))
  //       .join(' ');
  //   }
  //   return articleTitle;
  // } catch (e) {
  //   return articleTitle;
  // }
  return articleTitle
}

export const getFaqUrlFromTitle = (title) => {
  return encodeURIComponent(
    title &&
      filterURLWordSEO(title)
        .replace(/ /g, '-')
        .replace(/[&\/\\#, +()$~%.'":*?<>{}]/g, '')
        .replace(/[/\\]/g, '-')
        .toLowerCase(),
  )
}

export const getTitleForArticleUrl = (title, articleId) => {
  return decodeURIComponent(
    `${getFaqUrlFromTitle(filterURLWordSEO(title))}-${articleId.toLowerCase()}`,
  )
}

export const isRenderingOnServer = () => {
  return typeof window === 'undefined'
}

// Filter top contact reason response data
export const filterSearchResponse = (responseData) => {
  const { data } = responseData
  if (!Array.isArray(data)) {
    return []
  }

  return data.map((article, index) => ({
    id: `suggestion_${index + 1}`,
    value: article.articleTitle || article.document_title,
    docid: article.articleId || article.document_id,
    rank: article.rank || '',
  }))
}

export const getSanitizedValue = (value) => {
  const returnValue = value ? value.trim() : ''
  try {
    return encodeURIComponent(returnValue)
  } catch (error) {
    return returnValue
  }
}

export function dataMasking(data) {
  if (_isString(data)) {
    return data.replace(maskRegEx, maskPattern)
  }

  return data
}

/*
 * applicable only for iframe having source of videos hosted on paypalobjects
 * @param { object } iframe html element
 * @returns { string } html string
 */
export const getArticleVideoIframeSrcDoc = (iframeElement) => {
  const { height, width, src } = iframeElement
  return `<html><body style="margin:0;overflow:hidden;"><video width="${width}" height="${height}" controls="true"><source src="${src}" /></video></body></html>`
}
